import Point from "./Point";

export default function triangleArea(a:Point, b:Point, c:Point) {
	return ((c.x*b.y - b.x*c.y) - (c.x*a.y - a.x*c.y) + (b.x*a.y - a.x*b.y)) /2;
};